import { render } from "./pcemulate.vue?vue&type=template&id=438838e6&scoped=true"
import script from "./pcemulate.vue?vue&type=script&lang=js"
export * from "./pcemulate.vue?vue&type=script&lang=js"

import "./pcemulate.vue?vue&type=style&index=0&id=438838e6&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438838e6"]])

export default __exports__